import styled from 'styled-components';
import { StyledUiContainerProps } from 'components';

export const SiteViewContainer = styled.div<StyledUiContainerProps>`
    padding: 1.5rem 3.125rem 0px;
`;
